import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule, NgbNavModule } from "@ng-bootstrap/ng-bootstrap";
import { CheckboxModule } from "primeng/checkbox";
import { DropdownModule } from "primeng/dropdown";
import { RadioButtonModule } from "primeng/radiobutton";
import { MultiSelectModule } from "primeng/multiselect";
import { ToastModule } from "primeng/toast";
import { TooltipModule } from "primeng/tooltip";
import { AnnotationModule } from "src/app/annotation/annotation.module";
import { SharedModule } from "src/app/shared/shared.module";
import { SharedSurveyModule } from "../shared/sharedSurvey.module";
import { OutsideSurveyAddressComponent } from "./outside-survey-address/outside-survey-address.component";
import { OutsideSurveyContactComponent } from "./outside-survey-contact/outside-survey-contact.component";
import { OutsideSurveyPhotoFormComponent } from "./outside-survey-photo/outside-survey-photo-form/outside-survey-photo-form.component";
import { OutsideSurveyPhotoComponent } from "./outside-survey-photo/outside-survey-photo.component";
import { OutsideSurveySurveyorComponent } from "./outside-survey-surveyor/outside-survey-surveyor.component";
import { OutsideSurveyTechnicalComponent } from "./outside-survey-technical/outside-survey-technical.component";
import { OutsideSurveyUnitComponent } from "./outside-survey-unit/outside-survey-unit.component";
import { OutsideSurveyValidateRemarksComponent } from "./outside-survey-validate-remarks/outside-survey-validate-remarks.component";
import { OutsideSurveyValidateComponent } from "./outside-survey-validate/outside-survey-validate.component";
import { OutsideSurveyComponent } from "./outside-survey.component";

@NgModule({
  declarations: [
    OutsideSurveyComponent,
    OutsideSurveyAddressComponent,
    OutsideSurveyPhotoComponent,
    OutsideSurveyUnitComponent,
    OutsideSurveyTechnicalComponent,
    OutsideSurveyContactComponent,
    OutsideSurveyValidateComponent,
    OutsideSurveyValidateRemarksComponent,
    OutsideSurveySurveyorComponent,
    OutsideSurveyPhotoFormComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule,
    NgbNavModule,
    ToastModule,
    MultiSelectModule,
    AnnotationModule,
    CheckboxModule,
    SharedSurveyModule,
    SharedModule,
    TooltipModule,
    DropdownModule,
    RadioButtonModule,
  ],
})
export class OutsideSurveyModule {}
